import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable, of } from "rxjs";
import { HttpService } from "./http.service";
import { AuthService } from "app/auth-core/auth.service";
import { MealPlan, MealPlanDTO, MealPlanItem, MealPlanItemDTO, Recipe } from "app/models/recipe.model";
import { IngrediantService } from "./ingrediant.service";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class MealPlanService {
	private baseUrl = environment.services.apiBasePath + "/SWITCH_FOOD_EX_MEAL_PLANS";
	constructor(private _httpService: HttpService, private _authService: AuthService, private _foodItemsService: IngrediantService) {
	}
	public getMyPlans= (recipes: Recipe[]): Observable<MealPlan[]> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId;
		return this._httpService.get(url, "json").pipe(
			map((elements) => {
				let result: MealPlan[];
				result = elements.map((dto) => {
					return this.fromDTOToMealPlan(dto, recipes);
				})
				return result;

			})
		)
	}

	public getMyPlan= (id: string, recipes: Recipe[]): Observable<MealPlan> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId + "/" + id;
		return this._httpService.get(url, "json").pipe(
			map((element) => {
				let result: MealPlan = this.fromDTOToMealPlan(element, recipes);;
				return result;
			})
		)
	}
	
	
	public delete = (id: any): Observable<any> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId + "/" + id;
		return this._httpService.delete(url);
	}
	public saveOrUpdate = (mealPlan: MealPlan): Observable<any> => {
		let url = this.baseUrl + "/" + this._authService.tokenUserId;
		let toSave = this.fromMealPlanToDTO(mealPlan);

		if (toSave.id)
			return this._httpService.put(url + "/" + toSave.id, toSave, "json");
		return this._httpService.post(url, toSave, "json");
	}
	

	private fromDTOToMealPlanItem = (dto:MealPlanItemDTO, recipes: Recipe[]): MealPlanItem => {
		let result: MealPlanItem = null;
		if (dto) {
			result = new MealPlanItem();
			recipes.forEach(element => {
				if (element.id == dto.recipeIdDinner) {
					result.recipeClassDinner = element.envScoreClass;
					result.recipeIdDinner = element.id;
					result.recipeNameDinner = element.recipeName;
				}
				if (element.id == dto.recipeIdLunch) {
					result.recipeClassLunch = element.envScoreClass;
					result.recipeIdLunch = element.id;
					result.recipeNameLunch = element.recipeName;
				}
			});
		}
		return result;
	}
	public fromDTOToMealPlan = (dto: MealPlanDTO, recipes: Recipe[]): MealPlan => {
		let result: MealPlan = null;
		if (dto) {
			result  = new MealPlan();
			result.id = dto.id;
			result.planName = dto.planName;
			result.lastUpdate = dto.lastUpdate;
			result.monday = [this.fromDTOToMealPlanItem(dto.monday[0], recipes), this.fromDTOToMealPlanItem(dto.monday[1], recipes), this.fromDTOToMealPlanItem(dto.monday[2], recipes)];
			result.tuesday = [this.fromDTOToMealPlanItem(dto.tuesday[0], recipes), this.fromDTOToMealPlanItem(dto.tuesday[1], recipes), this.fromDTOToMealPlanItem(dto.tuesday[2], recipes)];
			result.wednesday = [this.fromDTOToMealPlanItem(dto.wednesday[0], recipes), this.fromDTOToMealPlanItem(dto.wednesday[1], recipes), this.fromDTOToMealPlanItem(dto.wednesday[2], recipes)];
			result.thursday = [this.fromDTOToMealPlanItem(dto.thursday[0], recipes), this.fromDTOToMealPlanItem(dto.thursday[1], recipes), this.fromDTOToMealPlanItem(dto.thursday[2], recipes)];
			result.friday = [this.fromDTOToMealPlanItem(dto.friday[0], recipes), this.fromDTOToMealPlanItem(dto.friday[1], recipes), this.fromDTOToMealPlanItem(dto.friday[2], recipes)];
			result.saturday = [this.fromDTOToMealPlanItem(dto.saturday[0], recipes), this.fromDTOToMealPlanItem(dto.saturday[1], recipes), this.fromDTOToMealPlanItem(dto.saturday[2], recipes)];
			result.sunday = [this.fromDTOToMealPlanItem(dto.sunday[0], recipes), this.fromDTOToMealPlanItem(dto.sunday[1], recipes), this.fromDTOToMealPlanItem(dto.sunday[2], recipes)];

		}
		return result;
	} 

	private fromMealPlanItemToDTO = (mealPlanItem: MealPlanItem): MealPlanItemDTO => {
		if (mealPlanItem) return {
			recipeIdDinner: mealPlanItem.recipeIdDinner,
			recipeIdLunch: mealPlanItem.recipeIdLunch,
		}
		return null;
	}
	public fromMealPlanToDTO = (mealPlan: MealPlan): MealPlanDTO => {
		let result: MealPlanDTO = null;
		if (mealPlan) {
			result  = new MealPlanDTO();
			result.id = mealPlan.id;
			result.planName = mealPlan.planName;
			result.lastUpdate = mealPlan.lastUpdate;
			result.monday = [this.fromMealPlanItemToDTO(mealPlan.monday[0]), this.fromMealPlanItemToDTO(mealPlan.monday[1]), this.fromMealPlanItemToDTO(mealPlan.monday[2])];
			result.tuesday = [this.fromMealPlanItemToDTO(mealPlan.tuesday[0]),this.fromMealPlanItemToDTO(mealPlan.tuesday[1]),this.fromMealPlanItemToDTO(mealPlan.tuesday[2])];
			result.wednesday = [this.fromMealPlanItemToDTO(mealPlan.wednesday[0]), this.fromMealPlanItemToDTO(mealPlan.wednesday[1]), this.fromMealPlanItemToDTO(mealPlan.wednesday[2])];
			result.thursday = [this.fromMealPlanItemToDTO(mealPlan.thursday[0]), this.fromMealPlanItemToDTO(mealPlan.thursday[1]), this.fromMealPlanItemToDTO(mealPlan.thursday[2])];
			result.friday = [this.fromMealPlanItemToDTO(mealPlan.friday[0]), this.fromMealPlanItemToDTO(mealPlan.friday[1]), this.fromMealPlanItemToDTO(mealPlan.friday[2])];
			result.saturday = [this.fromMealPlanItemToDTO(mealPlan.saturday[0]), this.fromMealPlanItemToDTO(mealPlan.saturday[1]), this.fromMealPlanItemToDTO(mealPlan.saturday[2])];
			result.sunday = [this.fromMealPlanItemToDTO(mealPlan.sunday[0]), this.fromMealPlanItemToDTO(mealPlan.sunday[1]), this.fromMealPlanItemToDTO(mealPlan.sunday[2])];

		}
		console.log("from", mealPlan);
		console.log("TO", result);
		
		return result;
	}
	
}